import * as Cookie from 'tiny-cookie'
import Handlebars from 'handlebars/dist/handlebars.js'
import HTTP from 'axios'

// Include the ui.json
import UIJSON from '@/workflows/ui.json'

// Include all the workflows
import preload from '@/workflows/conf/preload.json';
import submit from '@/workflows/conf/submit.json';
import login from '@/workflows/conf/login_workflow.json';
import preferences from '@/workflows/conf/preferences.json';
import grid from '@/workflows/conf/grid.json';
import test from '@/workflows/conf/test_workflow.json';

// Append all into workflow json
var WorkflowJSON = [];
WorkflowJSON = WorkflowJSON.concat(preload).concat(submit).concat(login).concat(preferences).concat(test).concat(grid)

window.UIJSON = UIJSON;

// Notifications
import Vue from 'vue'
import Notifications from 'vue-notification'
Vue.use(Notifications)

// jQuery
import $ from "jquery";

Handlebars.registerHelper('json', function (context) {
    return JSON.stringify(context);
});

Handlebars.registerHelper('email', function (context) {
    let tmp = {};
    tmp.email = context.email;
    return JSON.stringify(tmp);
});
Handlebars.registerHelper('verify', function (context) {

    context.email = Cookie.getCookie('signup_email');
    return JSON.stringify(context);
});
/**
 * @mixin
 */
export const Workflow = {
    // Props for ui elements to send while initiating the route
    props: {
        workflow_params:
        {
        }
    },
    methods: {

        start(id) {

            var data = {};

            console.log(WorkflowJSON)

            // Clone as handlebars changes the objects
            var workflow_json_copy = JSON.parse(JSON.stringify(WorkflowJSON));

            // Get start workflow id
            var actions = workflow_json_copy.find(item => {
                return item.id == id
            })

            if (!actions) {
                this.$notify({
                    group: 'foo',
                    title: 'Error',
                    type: 'error',
                    text: 'Workflow not found'
                });
                console.log("Workflow not found");
                return;
            }

            var json = actions.workflow;

            // Get start node
            var next_code = json.find(item => {
                return item.type == 'start'
            })

            // Execute next code
            this.execute_next_code(json, next_code.next.success, {})
        },
        get_hb_json(data) {

            // Mix both data and form
            var hb = data;

            // Add route params
            hb.route = {};
            hb.route.params = this.$route.params;

            // Add app_ui json 
            if (UIJSON)
                hb.ui_json = UIJSON

            // Add form data
            if (this.form)
                hb.form = this.form;

            return hb;
        },
        execute_next_code(json, node_id, data) {

            // console.log('Executing ' + node_id + " " + JSON.stringify(data))

            var next_code = json.find(item => {
                return item.id == node_id
            })

            if (!next_code) {
                console.log("Not found " + node_id);
                return;
            }

            // Apply handlebars on each key/value pairs
            var $s = this;
            Object.keys(next_code).forEach(function (keyValue) {
                if (typeof next_code[keyValue] != 'object') {

                    var value = next_code[keyValue];
                    // Handlebars compile all the data
                    var template = Handlebars.compile(value);
                    next_code[keyValue] = template($s.get_hb_json(data))

                    // console.log("Compiling handlebars " + keyValue + " " + value + " with " + JSON.stringify($s.get_hb_json(data)) + " " + next_code[keyValue]);
                }
            });

            //Execute Get next node
            eval("this." + next_code.type)(json, next_code, data);
        },

        validate(json, props, data) {

            console.log('validate ' + JSON.stringify(props))

            // Validate
            var $s = this;
            this.$validator.validateAll().then((result) => {
                console.log('result', result);
                if (result) {
                    console.log("Form validated ")
                    $s.execute_next_code(json, props.next.success, data)
                }
                else {
                    console.log("Form not validated")
                    $s.execute_next_code(json, props.next.failure, data)
                }
            })
        },
        set_cookie(json, props, data) {

            console.log('set_cookie ' + JSON.stringify(props))

            // Set Cookie
            Cookie.setRaw(props.key, props.value, {
                expires: props.expiry
            });

            // Call next
            this.execute_next_code(json, props.next.success, data)
        },
        get_cookie(json, props, data) {
            data[props.var] = Cookie.get(props.key);

            // Call next
            this.execute_next_code(json, props.next.success, data)
        },
        delete_cookie(json, props, data) {
            Cookie.remove(props.key);

            // Call next
            this.execute_next_code(json, props.next.success, data)
        },
        ajax(json, props, data) {
            console.log('ajax ' + JSON.stringify(props))
            console.log(props)

            /*this.$http.get(props.url, {})*/

            HTTP({
                method: props.method,
                url: props.url,
                data: props.data
            }).then((response) => {
                data[props.var] = response;
                console.log(response);

                // Call success
                this.execute_next_code(json, props.next.success, data)
            }, (error) => {
                console.log(error);

                // Call failure
                this.execute_next_code(json, props.next.failure, data)
            })
        },
        navigate(json, props, data) {
            this.$router.push(props.url);
            this.execute_next_code(json, props.next.success, data)
        },
        set_var(json, props, data) {
            data[props.key] = props.value;
            this.execute_next_code(json, props.next.success, data)
        },
        set_local_storage(json, props, data) {

        },
        get_local_storage(json, props, data) {

        },
        alert(json, props, data) {
            console.log('alert ' + JSON.stringify(props))

            this.$notify({
                group: 'foo',
                title: props.title,
                type: props.alert_type,
                text: props.message
            });

            // Call next
            this.execute_next_code(json, props.next.success, data)
        },
        js(json, props, data) {

            console.log('js ' + JSON.stringify(props))
            var js_function = eval("(" + props.code + ")");
            var ret = js_function(data, this);
            if (ret)
                data = ret;

            console.log(data);

            // Call next
            this.execute_next_code(json, props.next.success, data)
        },
        deserialize_form(json, props, data) {
            console.log('deserialize ' + JSON.stringify(props))

            // Parse the json message
            var response = JSON.parse(props.data);

            console.log("Deserializing")

            // this.form=response;
            this.formFields.forEach(field => {
                if (response.hasOwnProperty(field.name)) {
                    this.form[field.name] = response[field.name];
                    field.value = response[field.name];

                    console.log("Setting")
        
                    // VERY bad way to set in dom - we will change it later
                    if (document.getElementsByName(field.name)[0])
                        document.getElementsByName(field.name)[0].value =
                            response[field.name];
                }
            });

            // Call next
            this.execute_next_code(json, props.next.success, data)
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/workflow.js